import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { Button, primaryTheme } from '@repo/ui/components/Buttons';
import { Spacer } from '@repo/ui/components/Spacer';
import { H2, P2 } from '@repo/ui/components/Typography';
import { useNewThemeActive } from '@repo/ui/theming';

import usePaymentSuccessModalData from '../hooks/usePaymentSuccessModalData';

import { LeftColumn, RightColumn, ImageWrapper } from './styles';
import { SubscriptionSuccessModalContentProps } from './types';
import useSubscriptionSuccessTracking from './useSubscriptionSuccessTracking';

const SubscriptionSuccessContent: React.FC<
  SubscriptionSuccessModalContentProps
> = ({ onContinueClick, subscription, plan, singlePayment }) => {
  const data = usePaymentSuccessModalData({
    subscription,
    plan,
    singlePayment,
  });
  useSubscriptionSuccessTracking(singlePayment);

  const isNewThemeActive = useNewThemeActive();

  return (
    <>
      <LeftColumn>
        <div>
          <Spacer height="12px" />
          <H2>{data.title}</H2>
          <Spacer height="16px" />
          <P2>{data.description}</P2>
          <Spacer height="24px" />
        </div>
        <Button
          label={data.buttonLabel}
          name="continueSubscriptionButton"
          theme={{ ...primaryTheme, padding: '12px' }}
          width="unset"
          onClick={onContinueClick}
        />
      </LeftColumn>
      <RightColumn>
        <ImageWrapper
          background={data.imageUrl}
          isNewThemeActive={isNewThemeActive}
        />
      </RightColumn>
    </>
  );
};

export default withEventScope(SubscriptionSuccessContent, {
  feature: 'subscriptionSuccessContent',
});
